var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rows),function(row){return _c('delivery-lead-single-debug',{key:row.id,attrs:{"app_id":_vm.app_id,"delivery_lead_id":row.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }